import "./PopupStyle.css";
import { useState, useEffect, useRef } from "react";
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { OrbitControls } from "./OrbitControls";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { styled, useTheme, createTheme } from "@mui/material/styles";
// import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { CSS2DRenderer, CSS2DObject } from "./css2d";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Box, useMediaQuery } from "@mui/material";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import DollhouseView from "../components/DollhouseView";
import { leftBarVisibility } from "./SideBar";
import { Lights3D } from "../scripts/viewer3d/lights3d";
import ProgressBar from "../loader";
import {
  ARIA,
  BELLAGIO,
  PARK_MGM,
  VDARA,
  DOLBY,
  THE_COSMOPOLITAN,
  NOMAD,
  TMOBILE,
  Modal_Left,
  Modal_Left_Display,
  Modal_Left_Top,
  Modal_Left_Top_Display,
  Modal_Right,
  Modal_Right_Display,
  Modal_Right_Top,
  Modal_Right_Top_Display,
  Modal_Right_Bottom,
  Modal_Right_Bottom_Display,
  Modal_Left_Bottom,
  Modal_Left_Bottom_Display,
} from "../scripts/core/constants";

import { gsap } from "gsap";
import isometricmodel from "../assets/model/new/Isometric_View_BAKED_PC_V003.gltf";
import isometricmodel_mobile from "../assets/model/new/Isometric_View_BAKED_Mobile_V004.gltf";

// import isometricmodel from "../assets/model/Isometric_View_BAKED_V002.gltf";
// import aria_logo from "../assets/images/aria_logo.png";
// import bagio_logo from "../assets/images/bagio_logo.png";
// import cosmo_logo from "../assets/images/cosmo_logo.png";
// import park_mgm_logo from "../assets/images/park_mgm_logo.png";
// import vdara_logo from "../assets/images/vdara_logo.png";
// import nomad_logo from "../assets/images/nomad_logo.png";
import CirclePopupSVG from "../assets/images/modal-circle.svg";
import scenebg from "../assets/images/scene-bg_2.png";
// import tmobilearena from "../assets/images/tmobilearena.png";
import CloseIcon from "@mui/icons-material/Close";
import isometric_logo from "../assets/images/isometric-logo.png";
import $ from "jquery";
const _raycaster = new THREE.Raycaster();
const _mouse = new THREE.Vector2();
let _mouseX, setMouseX;
let _mouseY, setMouseY;

let _scene = new THREE.Scene();
let _camera;
let _controls;
let _renderer;
let _labelRenderer;
let setlabelRenderer;
let setRenderer;
let _canvasContainer;
let hoverBuilding;
let _loadModel = false;
let _xs, _sm, _tablets;
// let __SpacingValue, setSpacingValue;
let BuildingName, setBuildingname;
let loadingpercentage, setloadingpercentage;
let BuildingLogo, setBuildingLogo;
let BuildingInformation, setBuildingInformation;
let buildClicked = true;
let loadingStatus, setloadingStatus;
let modalplacement, setModalplacement;
let modalcontent, setModalcontent;
let modalPaddingLeft, setModalPaddingLeft;
let modalPaddingRight, setModalPaddingRight;
// let modalDir, setmodalDir;
let __enabled = false;
let CanvasMargin = 320;
let LeftMarginValue = 0;
let status = false;
let isActive, setIsActive;
let popUpFlag, setpopUpFlag;
let mouseDown, setmouseDown;
let isometricObj = null;

const lastPoint = { x: null, y: null };
let popupinfocontent = null;
let ARIA_INFORMATION = null;
let VDARA_INFORMATION = null;
let BELLAGIO_INFORMATION = null;
let PARK_MGM_INFORMATION = null;
let COSMO_INFORMATION = null;
let TMOBILE_INFORMATION = null;
let NOMAD_INFORMATION = null;
let DOLBY_INFORMATION = null;

const Modal_View = {
  RightTop: {
    modal: Modal_Right_Top,
    display: Modal_Right_Top_Display,
  },
  LeftTop: {
    modal: Modal_Left_Top,
    display: Modal_Left_Top_Display,
  },
  RightBottom: {
    modal: Modal_Right_Bottom,
    display: Modal_Right_Bottom_Display,
  },
  LeftBottom: {
    modal: Modal_Left_Bottom,
    display: Modal_Left_Bottom_Display,
  },
  Left: {
    modal: Modal_Left,
    display: Modal_Left_Display,
  },
  Right: {
    modal: Modal_Right,
    display: Modal_Right_Display,
  },
};
// console.log(Modal_View.Left);
export let ARIA_INFORMATION_LOGO = null;
export let VDARA_INFORMATION_LOGO = null;
export let BELLAGIO_INFORMATION_LOGO = null;
export let PARK_MGM_INFORMATION_LOGO = null;
export let COSMO_INFORMATION_LOGO = null;
export let TMOBILE_INFORMATION_LOGO = null;
export let NOMAD_INFORMATION_LOGO = null;
export let DOLBY_INFORMATION_LOGO = null;

let buildibgBox;

const PopUpItem = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  top: `${_mouseY}px`,
  left: `${_mouseX}px`,
  position: "absolute",
  width: "180px",
  height: "170px",
  paddingLeft: `${modalPaddingLeft}px`,
  paddingRight: `${modalPaddingRight}px`,
  boxShadow: "none",
  // useMediaQuery('(min-width:1020px) and (max-width:1180px)')
  [theme.breakpoints.down("md")]: {
    width: 0,
    paddingLeft: 0,
    right: "210px",
    height: "100%",
    zIndex: 4,
    ".isometric-modal-right::after,.isometric-modal-right::before,.isometric-modal-right .point":
      {
        display: "none",
      },
  },
}));

const ZoomItem = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  position: "absolute",
  zIndex: 3,
  bottom: "10px",
  right: "10px",
  padding: 0,
  width: "auto",
  height: "auto",
  border: "none",
  borderRadius: 10,
  color: "#ffffff",
  boxShadow: "none",
}));

const ZoomIcons = {
  background: "#000000 0% 0% no-repeat padding-box",
  margin: "2px",
  borderRadius: "6px",
  width: "37px",
  height: "37px",
  padding: "5px",
  "&:hover": {
    background: "#000000 0% 0% no-repeat padding-box",
  },
};

function __loadingProgrss() {
  const manager = new THREE.LoadingManager();
  manager.onProgress = function (url, itemsLoaded, itemsTotal) {
    setloadingpercentage((itemsLoaded / itemsTotal) * 100);
    if ((itemsLoaded / itemsTotal) * 100 >= 100) {
      setloadingStatus(false);
      leftBarVisibility(true);
      LeftMarginValue = 320;
      __animateIsometric();
    }
  };

  manager.onError = function (url) {
    console.log("There was an error loading " + url);
  };
  return manager;
}

function __loadGltfModel(
  scene,
  glbPath,
  options,
  name,
  pos,
  visible,
  setloader,
  handleThreeModel,
  selectedvalue
) {
  // let { receiveShadow, castShadow } = options;
  return new Promise((resolve, reject) => {
    let dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderConfig({ type: "js" });
    dracoLoader.setDecoderPath(
      "https://www.gstatic.com/draco/versioned/decoders/1.5.6/"
    );
    let loader;
    if (setloader === true) {
      loader = new GLTFLoader(__loadingProgrss());
    } else {
      loader = new GLTFLoader();
    }
    loader.setDRACOLoader(dracoLoader);
    loader.load(
      glbPath,
      (gltf) => {
        let obj = gltf.scene;
        obj.name = name;
        obj.position.y = pos.y;
        obj.position.x = pos.x;
        // obj.position.z = pos.z;
        // __increaseLight(obj);
        handleThreeModel(obj);
        _scene.add(obj);
        isometricObj = obj;
        obj.visible = visible;

        resolve(obj);
      },
      undefined,
      function (error) {
        console.log(error);
        reject(error);
      }
    );
  });
}

/** 

function __increaseLight(object) {
  object.traverse((obj) => {
    if (obj.name.includes("Roads_Extras_and_Base")) {
      obj.material.transparent = true;
      obj.material.metalness = 0.2;
    }
    if (obj.name.includes("Building_7_L")) {
      obj.material.transparent = true;
      obj.material.metalness = 0.1;
    }
  });
}

*/
function __animateIsometric() {
  _loadModel = false;
  if (isometricObj === undefined) return;
  isometricObj.scale.set(0, 0, 0);
  const tl = gsap.timeline();
  tl.to(isometricObj.scale, 0.8, { x: 1, y: 1, z: 1 });

  setTimeout(() => {
    _loadModel = true;
  }, 16000);
}

function __isometricView() {
  setIsActive(false);
  __hideMeshe("ISOMETRIC", true, { x: 0, y: 0, z: 0 });
  _camera.position.set(3.5, 3, -4.6);
  _controls.screenSpacePanning = false;
  _controls.enablePan = false;
  _controls.enableRotate = true;
  _controls.maxDistance = 8;
}

function __hideMeshe(name, visibility, pos) {
  _scene.traverse((obj) => {
    if (obj.name.includes(name)) {
      obj.visible = visibility;
      obj.position.set(pos.x, pos.y, pos.z);
    }
  });
}

function __zoomIn() {
  _controls.dollyIn();
  setpopUpFlag(true);
  setIsActive(false);
  __enableRenderer();
}

function __zoomOut() {
  _controls.dollyOut();
  setpopUpFlag(true);
  setIsActive(false);
  __enableRenderer();
}

const __css2Object = (e, object, _offsetX, _offsetY, modalview) => {
  __enableRenderer();
  // console.log('modalview', modalview);
  // console.log('aaa');
  var mesh = object;
  var selectedObject = _scene.getObjectByName("css2dPopup");

  if (selectedObject !== undefined) {
    _scene.remove(selectedObject);
  }

  var geometry = mesh.geometry;
  geometry.computeBoundingBox();
  var center = new THREE.Vector3();
  geometry.boundingBox.getCenter(center);
  mesh.localToWorld(center);

  const _centerPointer = document.createElement("div");
  _centerPointer.id = "labelcss2dPopup";
  const _centerPointerObj = new CSS2DObject(_centerPointer);
  _centerPointerObj.position.copy(center);
  _centerPointerObj.name = "css2dPopup";
  _scene.add(_centerPointerObj);

  const _vector = new THREE.Vector3();
  const _viewMatrix = new THREE.Matrix4();
  const _viewProjectionMatrix = new THREE.Matrix4();
  let _widthHalf = (window.innerWidth - LeftMarginValue) / 2;
  let _heightHalf = window.innerHeight / 2;

  _scene.updateMatrixWorld();
  _camera.updateMatrixWorld();
  _viewMatrix.copy(_camera.matrixWorldInverse);
  _viewProjectionMatrix.multiplyMatrices(_camera.projectionMatrix, _viewMatrix);
  _vector.setFromMatrixPosition(_centerPointerObj.matrixWorld);
  _vector.applyMatrix4(_viewProjectionMatrix);
  // console.log('object X');
  if (window.innerWidth > 1181 && window.innerWidth <= 1280) {
    // console.log("1280 if")
    // console.log("else bigger screen");
    // console.log('e.clientY - _canvasContainer.offsetLeft', e.clientY)
    console.log("x: ", _vector.x * _widthHalf + _widthHalf);
    console.log("y: ", -_vector.y * _heightHalf + _heightHalf);
    console.log("offsetX: ", _offsetX);
    console.log("offsetY: ", _offsetY);
    // if ((e.clientX - _canvasContainer.offsetLeft) < (window.innerWidth - _canvasContainer.offsetLeft) / 2) {
    if (
      _vector.x * _widthHalf + _widthHalf <
      (window.innerWidth - _canvasContainer.offsetLeft) / 2
    ) {
      __setModalProperties(
        Modal_View.Right.display,
        Modal_View.Right.modal,
        0,
        445
      );
    } else {
      __setModalProperties(
        Modal_View.Left.display,
        Modal_View.Left.modal,
        0,
        445
      );
    }

    /** X position */
    if (
      _vector.x * _widthHalf + _widthHalf < 0 &&
      -_vector.y * _heightHalf + _heightHalf > 0 &&
      -_vector.y * _heightHalf + _heightHalf < 200
    ) {
      console.log("X < 0, (Y > 0 ,Y < 200)");
      __setModalProperties(
        Modal_View.RightBottom.display,
        Modal_View.RightBottom.modal,
        0,
        445
      );
      setMouseX(10);
      setMouseY(-_vector.y * _heightHalf + _heightHalf);
    } else if (
      _vector.x * _widthHalf + _widthHalf < 0 &&
      -_vector.y * _heightHalf + _heightHalf < 10
    ) {
      console.log("X < 0, Y < 0");
      __setModalProperties(
        Modal_View.RightBottom.display,
        Modal_View.RightBottom.modal,
        0,
        445
      );
      setMouseX(_offsetX + 25);
      setMouseY(80);
    } else if (
      _vector.x * _widthHalf + _widthHalf > 0 &&
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf < 10
    ) {
      console.log("(X > 0, X< innerwidth/2) && (Y < 0)");
      __setModalProperties(
        Modal_View.RightBottom.display,
        Modal_View.RightBottom.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf);
      setMouseY(80);
    } else if (
      _vector.x * _widthHalf + _widthHalf > 0 &&
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > 10 &&
      -_vector.y * _heightHalf + _heightHalf < 200
    ) {
      console.log("(X > 0, X < innerwidth/2) && (Y > 0, Y < 200)");
      __setModalProperties(
        Modal_View.RightBottom.display,
        Modal_View.RightBottom.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + 50);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      _vector.x * _widthHalf + _widthHalf <
        window.innerWidth - _canvasContainer.offsetLeft &&
      -_vector.y * _heightHalf + _heightHalf > 10 &&
      -_vector.y * _heightHalf + _heightHalf < 200
    ) {
      console.log("( X > innerwidth/2 < innerwidth) && (Y > 0, Y < 200)");
      __setModalProperties(
        Modal_View.LeftBottom.display,
        Modal_View.LeftBottom.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf - 360);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + 10);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        window.innerWidth - _canvasContainer.offsetLeft &&
      -_vector.y * _heightHalf + _heightHalf > 10 &&
      -_vector.y * _heightHalf + _heightHalf < 200
    ) {
      console.log("( X > innerwidth) && (Y > 0, Y < 200)");
      __setModalProperties(
        Modal_View.LeftBottom.display,
        Modal_View.LeftBottom.modal,
        0,
        445
      );
      setMouseX(window.innerWidth - _canvasContainer.offsetLeft - 400);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + 100);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf < 10
    ) {
      console.log("X > inner width/2, Y < 0");
      __setModalProperties(
        Modal_View.LeftBottom.display,
        Modal_View.LeftBottom.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf - 360);
      setMouseY(80);
    } else if (
      _vector.x * _widthHalf + _widthHalf < 0 &&
      -_vector.y * _heightHalf + _heightHalf > 200
    ) {
      console.log("X < 0, Y > 200");
      setMouseX(85);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + _offsetY);
    } else if (
      _vector.x * _widthHalf + _widthHalf > 0 &&
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > 200 &&
      -_vector.y * _heightHalf + _heightHalf < window.innerHeight
    ) {
      console.log("X > 0, Y > 200, Y < innerHeight");
      _offsetX = 60;
      _offsetY = -140;
      __setModalProperties(
        Modal_View.Right.display,
        Modal_View.Right.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf + _offsetX);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + _offsetY);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      _vector.x * _widthHalf + _widthHalf <
        window.innerWidth - _canvasContainer.offsetLeft &&
      -_vector.y * _heightHalf + _heightHalf > 200 &&
      -_vector.y * _heightHalf + _heightHalf < window.innerHeight
    ) {
      console.log(
        "X > window width / 2, X < window inner width Y > 200, Y < innerheight"
      );
      _offsetX = -420;
      _offsetY = -160;
      __setModalProperties(
        Modal_View.Left.display,
        Modal_View.Left.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf + _offsetX);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + _offsetY);
    } else if (
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > 200 &&
      -_vector.y * _heightHalf + _heightHalf < window.innerHeight
    ) {
      console.log("X > inner width, Y > 200 , y< inner height");
      __setModalProperties(
        Modal_View.RightTop.display,
        Modal_View.RightTop.modal,
        0,
        445
      );
      setMouseX(window.innerWidth - _canvasContainer.offsetLeft - 450);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + _offsetY);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > window.innerHeight
    ) {
      console.log("X > inner width / 2, Y > inner height");
      __setModalProperties(
        Modal_View.LeftTop.display,
        Modal_View.LeftTop.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf + _offsetX + 80);
      setMouseY(window.innerHeight + (_offsetY - 85));
    } else if (
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > window.innerHeight
    ) {
      console.log("X < inner width, Y > inner height");
      __setModalProperties(
        Modal_View.RightTop.display,
        Modal_View.RightTop.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf);
      setMouseY(window.innerHeight + (_offsetY - 85));
    }
  } else if (window.innerWidth >= 1281) {
    // console.log("else bigger screen");
    // console.log('e.clientY - _canvasContainer.offsetLeft', e.clientY)
    // console.log('x: ', _vector.x * _widthHalf + _widthHalf);
    // console.log('y: ', -_vector.y * _heightHalf + _heightHalf);
    // console.log('offsetX: ', _offsetX);
    // console.log('offsetY: ', _offsetY);
    // if ((e.clientX - _canvasContainer.offsetLeft) < (window.innerWidth - _canvasContainer.offsetLeft) / 2) {
    if (
      _vector.x * _widthHalf + _widthHalf <
      (window.innerWidth - _canvasContainer.offsetLeft) / 2
    ) {
      __setModalProperties(
        Modal_View.Right.display,
        Modal_View.Right.modal,
        0,
        445
      );
    } else {
      __setModalProperties(
        Modal_View.Left.display,
        Modal_View.Left.modal,
        0,
        445
      );
    }

    /** X position */
    if (
      _vector.x * _widthHalf + _widthHalf < 0 &&
      -_vector.y * _heightHalf + _heightHalf > 0 &&
      -_vector.y * _heightHalf + _heightHalf < 200
    ) {
      // console.log("X < 0, (Y > 0 ,Y < 200)");
      __setModalProperties(
        Modal_View.RightBottom.display,
        Modal_View.RightBottom.modal,
        0,
        445
      );
      setMouseX(10);
      setMouseY(-_vector.y * _heightHalf + _heightHalf);
    } else if (
      _vector.x * _widthHalf + _widthHalf < 0 &&
      -_vector.y * _heightHalf + _heightHalf < 10
    ) {
      // console.log("X < 0, Y < 0");
      __setModalProperties(
        Modal_View.RightBottom.display,
        Modal_View.RightBottom.modal,
        0,
        445
      );
      setMouseX(_offsetX + 25);
      setMouseY(80);
    } else if (
      _vector.x * _widthHalf + _widthHalf > 0 &&
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf < 10
    ) {
      // console.log("(X > 0, X< innerwidth/2) && (Y < 0)");
      __setModalProperties(
        Modal_View.RightBottom.display,
        Modal_View.RightBottom.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf);
      setMouseY(80);
    } else if (
      _vector.x * _widthHalf + _widthHalf > 0 &&
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > 10 &&
      -_vector.y * _heightHalf + _heightHalf < 200
    ) {
      // console.log("(X > 0, X < innerwidth/2) && (Y > 0, Y < 200)");
      __setModalProperties(
        Modal_View.RightBottom.display,
        Modal_View.RightBottom.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + 50);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      _vector.x * _widthHalf + _widthHalf <
        window.innerWidth - _canvasContainer.offsetLeft &&
      -_vector.y * _heightHalf + _heightHalf > 10 &&
      -_vector.y * _heightHalf + _heightHalf < 200
    ) {
      // console.log("( X > innerwidth/2 < innerwidth) && (Y > 0, Y < 200)");
      __setModalProperties(
        Modal_View.LeftBottom.display,
        Modal_View.LeftBottom.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf - 360);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + 100);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        window.innerWidth - _canvasContainer.offsetLeft &&
      -_vector.y * _heightHalf + _heightHalf > 10 &&
      -_vector.y * _heightHalf + _heightHalf < 200
    ) {
      // console.log("( X > innerwidth) && (Y > 0, Y < 200)");
      __setModalProperties(
        Modal_View.LeftBottom.display,
        Modal_View.LeftBottom.modal,
        0,
        445
      );
      setMouseX(window.innerWidth - _canvasContainer.offsetLeft - 400);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + 100);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf < 10
    ) {
      // console.log("X > inner width/2, Y < 0");
      __setModalProperties(
        Modal_View.LeftBottom.display,
        Modal_View.LeftBottom.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf - 360);
      setMouseY(80);
    } else if (
      _vector.x * _widthHalf + _widthHalf < 0 &&
      -_vector.y * _heightHalf + _heightHalf > 200
    ) {
      // console.log("X < 0, Y > 200");
      setMouseX(_offsetX + 25);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + _offsetY);
    } else if (
      _vector.x * _widthHalf + _widthHalf > 0 &&
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > 200 &&
      -_vector.y * _heightHalf + _heightHalf < window.innerHeight
    ) {
      // console.log("X > 0, Y > 200, Y < innerHeight");
      _offsetX = 160;
      _offsetY = -200;
      __setModalProperties(
        Modal_View.Right.display,
        Modal_View.Right.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf + _offsetX);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + _offsetY);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      _vector.x * _widthHalf + _widthHalf <
        window.innerWidth - _canvasContainer.offsetLeft &&
      -_vector.y * _heightHalf + _heightHalf > 200 &&
      -_vector.y * _heightHalf + _heightHalf < window.innerHeight
    ) {
      // console.log("X > window width / 2, X < window inner width Y > 200, Y < innerheight");
      _offsetX = -550;
      _offsetY = -200;
      __setModalProperties(
        Modal_View.Left.display,
        Modal_View.Left.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf + _offsetX);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + _offsetY);
    } else if (
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > 200 &&
      -_vector.y * _heightHalf + _heightHalf < window.innerHeight
    ) {
      // console.log("X > inner width, Y > 200 , y< inner height");
      __setModalProperties(
        Modal_View.RightTop.display,
        Modal_View.RightTop.modal,
        0,
        445
      );
      setMouseX(window.innerWidth - _canvasContainer.offsetLeft - 575);
      setMouseY(-_vector.y * _heightHalf + _heightHalf + _offsetY);
    } else if (
      _vector.x * _widthHalf + _widthHalf >
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > window.innerHeight
    ) {
      // console.log("X > inner width / 2, Y > inner height");
      __setModalProperties(
        Modal_View.LeftTop.display,
        Modal_View.LeftTop.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf + _offsetX + 140);
      setMouseY(window.innerHeight + (_offsetY - 85));
    } else if (
      _vector.x * _widthHalf + _widthHalf <
        (window.innerWidth - _canvasContainer.offsetLeft) / 2 &&
      -_vector.y * _heightHalf + _heightHalf > window.innerHeight
    ) {
      // console.log("X < inner width, Y > inner height");
      __setModalProperties(
        Modal_View.RightTop.display,
        Modal_View.RightTop.modal,
        0,
        445
      );
      setMouseX(_vector.x * _widthHalf + _widthHalf);
      setMouseY(window.innerHeight + (_offsetY - 85));
    }
  }
};

function removeBuildingBox() {
  if (buildibgBox !== null && buildibgBox !== undefined) {
    _scene.remove(buildibgBox);
    buildibgBox = null;
  }
}

function getDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    return "windows";
  }
  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  return undefined;
}

function isIOS() {
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return (
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform)
    );
  }
}

function isIpadOS() {
  return (
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform)
  );
}

let MgmModel = ({ exploreBtn, visibilityIsoMetric }) => {
  let refContainer = useRef();
  const theme = useTheme();
  const _customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1000,
        lg: 1200,
        xl: 1536,
      },
    },
  });
  [isActive, setIsActive] = useState(false);
  [popUpFlag, setpopUpFlag] = useState(true);
  [mouseDown, setmouseDown] = useState(true);
  [_renderer, setRenderer] = useState();
  [_labelRenderer, setlabelRenderer] = useState();
  [_mouseX, setMouseX] = useState();
  [_mouseY, setMouseY] = useState();
  [BuildingName, setBuildingname] = useState("");
  [loadingpercentage, setloadingpercentage] = useState(0);
  [loadingStatus, setloadingStatus] = useState(true);
  [BuildingLogo, setBuildingLogo] = useState(null);
  [BuildingInformation, setBuildingInformation] = useState(null);
  [modalplacement, setModalplacement] = useState("");
  [modalcontent, setModalcontent] = useState("");
  [modalPaddingLeft, setModalPaddingLeft] = useState();
  [modalPaddingRight, setModalPaddingRight] = useState();
  const [threeModel, setThreeModel] = useState(null);
  const stillbtn = "explore-icon";
  const animatebtn = "explore-icon explore-icon-trans";
  const [exploreaniFlag, setexploreaniflag] = useState(false);
  _xs = useMediaQuery(_customTheme.breakpoints.only("xs"));
  _sm = useMediaQuery(_customTheme.breakpoints.only("sm"));
  _tablets = useMediaQuery("(min-width:1000px) and (max-width:1180px)");
  // console.log('_tablets', _tablets)
  const handleThreeModel = (value) => {
    setThreeModel(value);
  };
  useEffect(() => {
    if (threeModel) {
      if (visibilityIsoMetric) {
        if (threeModel) {
          _scene.add(threeModel);
          __enableRenderer();
        }
      } else {
        const selectedObject = _scene.getObjectByName("ISOMETRIC");
        if (selectedObject) {
          selectedObject.traverse(function (child) {
            if (child.isMesh) {
              if (child.material) {
                child.material.dispose();
                child.geometry.dispose();
              }
            }
          });
          _scene.remove(selectedObject);
          __enabled = false;
        }
      }
    }
  }, [visibilityIsoMetric, threeModel]);

  useEffect(() => {
    let { current: container } = refContainer;
    if (_renderer) __destroyRenderer();

    if (container && !_renderer) {
      if (_xs || _sm) {
        CanvasMargin = 0;
      }
      _canvasContainer = container;
      _labelRenderer = new CSS2DRenderer();
      _labelRenderer.setSize(
        window.innerWidth - CanvasMargin,
        window.innerHeight
      );
      _labelRenderer.domElement.style.position = "absolute";
      _labelRenderer.domElement.style.top = "0px";
      _canvasContainer.appendChild(_labelRenderer.domElement);

      _renderer = __getRenderer();
      _renderer.setSize(window.innerWidth - CanvasMargin, window.innerHeight);
      _canvasContainer.appendChild(_renderer.domElement);
      __removeEventListerner(_canvasContainer);
      __addEventListerner(_canvasContainer);

      setlabelRenderer(_labelRenderer);
      setRenderer(_renderer);
      let width = window.innerWidth;
      let height = window.innerHeight;
      let bgloader = new THREE.TextureLoader();
      // scene.background = new THREE.Color("#d3d3d3");
      // let bgWidth, bgHeight;
      let bgTexture = bgloader.load(scenebg);
      // bgTexture.wrapS = THREE.MirroredRepeatWrapping;
      // bgTexture.wrapT = THREE.MirroredRepeatWrapping;
      bgTexture.magFilter = THREE.NearestFilter;
      _scene.background = bgTexture;
      _scene.background.encoding = THREE.sRGBEncoding;
      _camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 100);
      _camera.position.set(3.5, 3, -4.6);

      let lights = new Lights3D(_scene);
      lights.__addHemisphereLight();
      lights.__addAmbientlight();
      _controls = new OrbitControls(_camera, _renderer.domElement);
      _controls.screenSpacePanning = false;
      _controls.enablePan = false;
      // _controls.enableDamping = true;
      // _controls.dampingFactor = 0.03;
      _controls.maxDistance = 8;
      _controls.minDistance = 1.5;
      _controls.maxPolarAngle = Math.PI * 0.5;
      _controls.minPolarAngle = Math.PI * 0.23;
      _controls.maxZoom = 700;
      let gltfmodel = isometricmodel;

      const device = getDevice();
      if (device === undefined) {
        if (isIOS()) {
          gltfmodel = isometricmodel_mobile;
        }
        if (isIpadOS()) {
          gltfmodel = isometricmodel_mobile;
        }
      } else {
        gltfmodel = isometricmodel_mobile;
      }

      __loadGltfModel(
        _scene,
        gltfmodel,
        {
          receiveShadow: false,
          castShadow: false,
        },
        "ISOMETRIC",
        { x: 0, y: 0, z: 0 },
        true,
        true,
        handleThreeModel
      ).then(() => {
        __enableRenderer();
      });

      var req = null;
      _renderer.setAnimationLoop(__render.bind());
      __render();

      return () => {
        cancelAnimationFrame(req);
        _renderer.dispose();
      };
    }
  }, []);

  return (
    <>
      <Box
        component="div"
        id="ViewerRef"
        sx={{
          height: "100%",
          width: `calc(100% - ${LeftMarginValue}px)`,
          // width: {
          //   xs: "100%",
          //   sm: "100%",
          //   md: `calc(100% - ${LeftMarginValue}px)`,
          // },
          position: "absolute",
          overflow: "hidden",
          [_customTheme.breakpoints.down("md")]: {
            left: 0,
            width: "100%",
            // canvas: {
            //   width: "100% !important",
            // },
          },
        }}
        ref={refContainer}
      >
        {!loadingStatus && (
          <Box
            component="img"
            src={isometric_logo}
            sx={{
              height: "168px",
              position: "absolute",
              marginLeft: "40px",
              marginTop: "28px",
              [_customTheme.breakpoints.down("md")]: {
                height: "100px",
              },
            }}
          />
        )}
        {loadingStatus && <ProgressBar value={loadingpercentage} />}
        <Stack spacing={2}>
          <PopUpItem
            id="tansform-popup"
            className={isActive ? "popitem-show" : "popitem-hide"}
            // sx={{
            //   [_tablets]: {
            //     width: 0,
            //     paddingLeft: 0,
            //     right: "210px",
            //     height: "100%",
            //     zIndex: 4,
            //     ".isometric-modal-right::after,.isometric-modal-right::before,.isometric-modal-right .point":
            //     {
            //       display: "none",
            //     },
            //   },
            // }}
            onMouseEnter={() => {
              setpopUpFlag(false);
            }}
          >
            <IconButton
              id="closeDrawer"
              onClick={() => {
                setIsActive(false);
              }}
              sx={{
                background: "#000000",
                color: "#FFFFFF",
                position: "fixed",
                right: "211px",
                top: "10px",
                height: "35px",
                width: "35px",
                padding: "2px",
                border: "none",
                display: "none",
                [_customTheme.breakpoints.down("md")]: {
                  display: "block",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
            <Box
              id="hover-modal"
              component="div"
              className={isActive ? modalplacement : modalcontent}
              sx={{
                [_customTheme.breakpoints.down("md")]: {
                  width: "210px !important",
                  height: "100% !important",
                  // right: '210px'
                },
              }}
              onMouseEnter={() => {
                setpopUpFlag(false);
              }}
              onMouseLeave={() => {
                setpopUpFlag(true);
              }}
            >
              <span className="bg-span"></span>
              <Box
                component="div"
                className="point"
                onMouseEnter={() => {
                  setpopUpFlag(false);
                }}
              >
                <img
                  src={CirclePopupSVG}
                  alt=""
                  onMouseEnter={() => {
                    setpopUpFlag(false);
                  }}
                />
              </Box>
              <Box
                component="div"
                className="aria-content"
                onMouseEnter={() => {
                  setpopUpFlag(false);
                }}
                onMouseLeave={() => {
                  setpopUpFlag(true);
                }}
              >
                <div className="building-logo">
                  <img src={BuildingLogo} alt="" />
                </div>
                <Typography
                  gutterBottom
                  fontSize={12}
                  marginTop={1}
                  fontWeight="lighter"
                  letterSpacing={0}
                  color="#dddddd"
                  sx={{
                    fontFamily: "'Trade Gothic LT Std',sans-serif",
                    [_customTheme.breakpoints.down("md")]: {
                      height: "150px",
                      overflow: "auto",
                      // right: '210px'
                    },
                  }}
                >
                  {BuildingInformation}
                </Typography>
                <IconButton
                  aria-label="explore"
                  sx={{
                    width: "auto",
                    height: "34px",
                    borderRadius: "6px",
                    fontSize: "1.0rem",
                    fontWeight: "bold",
                    color: "#BDA770",
                    padding: 0,
                    marginTop: "6px",
                    fontFamily: "'Trade Gothic LT Std',sans-serif",
                  }}
                  onClick={() => {
                    if (BuildingName !== "T Mobile Arena") {
                      exploreBtn(BuildingName);
                    }
                  }}
                  onMouseEnter={() => {
                    setexploreaniflag(true);
                  }}
                  onMouseLeave={() => {
                    setexploreaniflag(false);
                  }}
                >
                  Explore
                  <KeyboardDoubleArrowRightIcon
                    className={exploreaniFlag ? animatebtn : stillbtn}
                  ></KeyboardDoubleArrowRightIcon>
                </IconButton>
              </Box>
            </Box>
          </PopUpItem>
        </Stack>
        {!loadingStatus && (
          <>
            <ZoomItem>
              <IconButton
                aria-label="zoomOut"
                sx={ZoomIcons}
                onClick={__zoomOut}
              >
                <ZoomOutIcon
                  sx={{
                    color: "#ffffff",
                    borderRadius: "6px",
                  }}
                />
              </IconButton>
              <IconButton aria-label="zoomIn" sx={ZoomIcons} onClick={__zoomIn}>
                <ZoomInIcon
                  sx={{
                    color: "#ffffff",
                    borderRadius: "6px",
                  }}
                />
              </IconButton>
            </ZoomItem>
          </>
        )}
      </Box>
    </>
  );
};

const __destroyRenderer = () => {
  _renderer.dispose();
  const _disposeElement = document.getElementById("ViewerRef");
  _disposeElement.removeChild(_labelRenderer.domElement);
  _disposeElement.removeChild(_renderer.domElement);
  _scene = new THREE.Scene();
  _camera = null;
  _controls = null;
  _renderer = null;
  _labelRenderer = null;
};

const __removeEventListerner = (container) => {
  container.removeEventListener("mousemove", __onMouseMove, false);
  container.removeEventListener("click", __onMouseClick, false);
  container.removeEventListener("dblclick", __onMousedblClick, false);
  container.removeEventListener("mousedown", __onMouseDown, false);
  container.removeEventListener("mouseup", __onMouseUp, false);
  container.removeEventListener("wheel", __onwheel, false);
  window.removeEventListener("focus", __onFocus, false);
  window.removeEventListener("visibilitychange", __onFocus, false);
  container.removeEventListener("touchstart", __onMouseDown, false);
  container.removeEventListener("touchend", __onMouseUp, false);
  container.removeEventListener("touchmove", __onMouseMove, false);
};

const __addEventListerner = (container) => {
  container.addEventListener("mousemove", __onMouseMove, false);
  container.addEventListener("click", __onMouseClick, false);
  container.addEventListener("dblclick", __onMousedblClick, false);
  container.addEventListener("mousedown", __onMouseDown, false);
  container.addEventListener("mouseup", __onMouseUp, false);
  container.addEventListener("wheel", __onwheel, false);
  window.addEventListener("focus", __onFocus, false);
  window.addEventListener("visibilitychange", __onFocus, false);
  container.addEventListener("touchstart", __onMouseDown, false);
  container.addEventListener("touchend", __onMouseUp, false);
  container.addEventListener("touchmove", __onMouseMove, false);
};

const __onwheel = () => {
  setpopUpFlag(true);
  setIsActive(false);
  __enableRenderer();
};
const __onFocus = () => {
  __enableRenderer();
  // console.log('focused')
};
const __getRenderer = () => {
  let renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true,
  });
  renderer.autoClear = true;
  renderer.shadowMap.enabled = false;
  renderer.shadowMapAutoUpdate = false;
  renderer.physicallyCorrectLights = true;
  renderer.shadowMapSoft = false;
  // renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.setClearColor(0x010101, 0);
  // renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.setPixelRatio(window.devicePixelRatio);
  return renderer;
};

const __disableRender = () => {
  if (!mouseDown) return;
  setTimeout(() => {
    __enabled = false;
    // console.log("renderer disabled");
  }, 8000);
};

const __render = () => {
  if (!__enabled && _loadModel) {
    return;
  }
  __enabled = false;
  _controls.update();
  _renderer.render(_scene, _camera);
};

const __resizeCanvas = (width, height) => {
  if (_xs || _sm) {
    LeftMarginValue = 0;
  }
  const wWidth = $(window).width();
  const wHeight = $(window).height();
  if (wWidth > wHeight) {
    _camera.aspect = width / height;
    _camera.updateProjectionMatrix();
    _renderer.setSize(width, height);
    _labelRenderer.setSize(width, height);

    __enableRenderer();
  }
};

const __currentBuildingStatus = (intersectObject) => {
  status = false;
  if (
    intersectObject === "Building_7_L" ||
    intersectObject === "Bellagio_Hotel_n_Casino" ||
    intersectObject === "Bellagio_M_Tower_2" ||
    intersectObject === "Vdara_Towers" ||
    intersectObject === "Building_5_L3" ||
    intersectObject === "NoMadaaaa" ||
    intersectObject === "Park_MGM_Eatery" ||
    intersectObject === "Park_MGM" ||
    intersectObject === "Park_MGM" ||
    intersectObject === "NoMad" ||
    intersectObject === "Dolby_Live_Buldn" ||
    intersectObject === "Cosmopolitan_Builds" ||
    intersectObject === "TCOLV_Builds_Set_1" ||
    intersectObject === "TCOLV_Builds_Set_2"
  ) {
    status = true;
    buildClicked = true;
  }
};

const __currentBuilding = (intersectObject) => {
  if (popupinfocontent) {
    if (intersectObject === "Building_7_L") {
      __setPopupValues(
        TMOBILE,
        TMOBILE_INFORMATION_LOGO,
        TMOBILE_INFORMATION,
        true
      );
    } else if (
      intersectObject === "Bellagio_Hotel_n_Casino" ||
      intersectObject === "Bellagio_M_Tower_2"
    ) {
      __setPopupValues(
        BELLAGIO,
        BELLAGIO_INFORMATION_LOGO,
        BELLAGIO_INFORMATION,
        true
      );
    } else if (intersectObject === "Vdara_Towers") {
      __setPopupValues(VDARA, VDARA_INFORMATION_LOGO, VDARA_INFORMATION, true);
    } else if (
      intersectObject === "Building_5_L3" ||
      intersectObject === "NoMadaaaa"
    ) {
      __setPopupValues(ARIA, ARIA_INFORMATION_LOGO, ARIA_INFORMATION, true);
    } else if (
      intersectObject === "Park_MGM_Eatery" ||
      intersectObject === "Park_MGM" ||
      intersectObject === "Park_MGM"
    ) {
      __setPopupValues(
        PARK_MGM,
        PARK_MGM_INFORMATION_LOGO,
        PARK_MGM_INFORMATION,
        true
      );
    } else if (intersectObject === "NoMad") {
      __setPopupValues(NOMAD, NOMAD_INFORMATION_LOGO, NOMAD_INFORMATION, true);
    } else if (intersectObject === "Dolby_Live_Buldn") {
      __setPopupValues(DOLBY, DOLBY_INFORMATION_LOGO, DOLBY_INFORMATION, true);
    } else if (
      intersectObject === "Cosmopolitan_Builds" ||
      intersectObject === "TCOLV_Builds_Set_1" ||
      intersectObject === "TCOLV_Builds_Set_2"
    ) {
      __setPopupValues(
        THE_COSMOPOLITAN,
        COSMO_INFORMATION_LOGO,
        COSMO_INFORMATION,
        true
      );
    }
  }
};

const __setPopupValues = (name, logo, info, flag) => {
  setBuildingname(name);
  setBuildingLogo(logo);
  setBuildingInformation(info);
  setIsActive(flag);
};

function __setModalProperties(placement, content, paddingleft, paddingright) {
  setModalplacement(placement);
  setModalcontent(content);
  setModalPaddingLeft(paddingleft);
  setModalPaddingRight(paddingright);
}

function __getMouseDir(e) {
  const leftOrRight =
    e.clientX > lastPoint.x
      ? "right"
      : e.clientX < lastPoint.x
      ? "left"
      : "none";

  if (leftOrRight === "left" && popUpFlag) {
    if (_xs || !_sm) {
      setpopUpFlag(true);
      setIsActive(false);
    }
  }
  lastPoint.x = e.clientX;
  lastPoint.y = e.clientY;
}

function __enableRenderer() {
  __enabled = true;
  // console.log(_camera.position)
}

function __onMouseDown() {
  setmouseDown(false);
}

function __onMouseUp() {
  setmouseDown(true);
}

function __onMouseMove(event) {
  __getMouseDir(event);
  if (!mouseDown) {
    __enableRenderer();
    setpopUpFlag(true);
    setIsActive(false);
  }
  const rect = _renderer.domElement.getBoundingClientRect();
  _mouse.x = ((event.clientX - rect.left) / (rect.right - rect.left)) * 2 - 1;
  _mouse.y = -((event.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;

  _raycaster.setFromCamera(_mouse, _camera);
  const intersects = _raycaster.intersectObjects(_scene.children);

  if (hoverBuilding !== undefined) {
    __enableRenderer();
    hoverBuilding.material.transparent = true;
    hoverBuilding.material.metalness = 0;
  }

  if (popUpFlag && mouseDown) {
    if (intersects.length > 0) {
      document.body.style.cursor = "default";
      let object = intersects[0].object;

      __currentBuilding(object.name);
      __currentBuildingStatus(object.name);
      hoverBuilding = object;
      if (status && object.visible === true) {
        document.body.style.cursor = "pointer";
        if (buildClicked) {
          if (window.innerWidth <= 1180) {
            __setModalProperties(Modal_Right_Display, Modal_Right, 0, 0);
          } else if (window.innerWidth > 1181 && window.innerWidth <= 1280) {
            if (
              event.clientX - _canvasContainer.offsetLeft <
              (window.innerWidth - _canvasContainer.offsetLeft) / 2
            ) {
              __css2Object(event, object, 60, -150);
            } else {
              __css2Object(event, object, -420, -160);
            }
          } else if (window.innerWidth >= 1281) {
            if (
              event.clientX - _canvasContainer.offsetLeft <
              (window.innerWidth - _canvasContainer.offsetLeft) / 2
            ) {
              __css2Object(event, object, 160, -200);
            } else {
              __css2Object(event, object, -550, -200);
            }
          }
          //  else {

          // }
        }
        buildClicked = false;
        object.material.transparent = true;
        object.material.metalness = 0.6;
      } else {
        removeBuildingBox();
        buildClicked = true;
      }
    } else {
      removeBuildingBox();
      buildClicked = true;
    }
  }
}

function __onMouseClick(event) {
  _mouse.x =
    ((event.clientX - _canvasContainer.offsetLeft) /
      _canvasContainer.clientWidth) *
      2 -
    1;
  _mouse.y =
    -(
      (event.clientY - _canvasContainer.offsetTop) /
      _canvasContainer.clientHeight
    ) *
      2 +
    1;
  _raycaster.setFromCamera(_mouse, _camera);

  const intersects = _raycaster.intersectObjects(_scene.children);

  if (intersects.length > 0) {
    document.body.style.cursor = "default";
  }
}

function __onMousedblClick() {
  setpopUpFlag(true);
  setIsActive(false);
}

function __getMarginValues(value) {
  LeftMarginValue = value;
}

const Viewer3D = ({
  exploreBtn,
  renderViewType,
  currentAreaSelected,
  mapRenderDatas,
  levelMapReset,
  dollhouseImages,
  sidebarStatus,
}) => {
  // console.log("mgmtest link")
  const [visibilityIsoMetric, setvisibilityIsoMetric] = useState(true);
  useEffect(() => {
    let url = process.env.REACT_APP_ISOMETRIC_POPUP_API;
    let dollhouseMapHoverInformationResponse = fetch(url);

    dollhouseMapHoverInformationResponse
      .then((response) => response.json())
      .then((jsondata) => {
        popupinfocontent = jsondata.popups;

        // console.log(popupinfocontent);

        popupinfocontent.forEach((val) => {
          if (val.building_id === "aria") {
            ARIA_INFORMATION = val.building_information;
            ARIA_INFORMATION_LOGO = val.logo;
          }
          if (val.building_id === "vdara") {
            VDARA_INFORMATION = val.building_information;
            VDARA_INFORMATION_LOGO = val.logo;
          }
          if (val.building_id === "bellagio") {
            BELLAGIO_INFORMATION = val.building_information;
            BELLAGIO_INFORMATION_LOGO = val.logo;
          }
          if (val.building_id === "park_mgm") {
            PARK_MGM_INFORMATION = val.building_information;
            PARK_MGM_INFORMATION_LOGO = val.logo;
          }
          if (val.building_id === "cosmo") {
            COSMO_INFORMATION = val.building_information;
            COSMO_INFORMATION_LOGO = val.logo;
          }
          if (val.building_id === "no_mad") {
            NOMAD_INFORMATION = val.building_information;
            NOMAD_INFORMATION_LOGO = val.logo;
          }
          if (val.building_id === "tmobile") {
            TMOBILE_INFORMATION = val.building_information;
            TMOBILE_INFORMATION_LOGO = val.logo;
          }
          if (val.building_id === "dolby_live") {
            DOLBY_INFORMATION = val.building_information;
            DOLBY_INFORMATION_LOGO = val.logo;
          }
        });
      })
      .catch((error) => {
        // handle the error
      });
  }, []);

  useEffect(() => {
    if (renderViewType === "ISOMETRIC_VIEW") {
      setvisibilityIsoMetric(true);
      setIsActive(false);
    } else {
      setvisibilityIsoMetric(false);
      setIsActive(false);
    }
  }, [renderViewType]);

  useEffect(() => {}, [currentAreaSelected]);
  return (
    <div style={{ margin: "0 auto", background: "#d3d3d3" }}>
      <div
        className={
          visibilityIsoMetric ? "render-view-active" : "render-view-inactive"
        }
      >
        <MgmModel
          exploreBtn={exploreBtn}
          visibilityIsoMetric={visibilityIsoMetric}
          sidebarStatus={sidebarStatus}
        />
      </div>
      <div
        className={
          !visibilityIsoMetric ? "render-view-active" : "render-view-inactive"
        }
      >
        <DollhouseView
          renderViewType={renderViewType}
          currentAreaSelected={currentAreaSelected}
          mapRenderDatas={mapRenderDatas}
          levelMapReset={levelMapReset}
          dollhouseImages={dollhouseImages}
        />
      </div>
    </div>
  );
};

export {
  Viewer3D,
  __isometricView,
  __hideMeshe,
  __resizeCanvas,
  __getMarginValues,
  __animateIsometric,
};

/***
  function objectHalfSize(geometry) {
    geometry.computeBoundingBox();
    let objectBox = geometry.boundingBox.clone();
    return objectBox.max.clone().sub(objectBox.min).divideScalar(2);
  }

  let PopupTrans = 'translate(' + (- 100 * 0.5) + '%,' + (- 100 * 0.5) + '%)' + 'translate(' +
    (_vector.x * _widthHalf + _widthHalf + 60) + 'px,' + (- _vector.y * _heightHalf + _heightHalf - 50) + 'px)';
  $("#tansform-popup").css('transform', PopupTrans);
/*
   if (_xs || _sm) {
  //   console.log('mobile')
  //   setMouseX("none");
  //   setMouseY(0);
  // } else if ((window.innerWidth > 900 && window.innerWidth <= 1180)) {
  //   console.log("ipad mobile")
  // } else {
  // __setModalProperties(
  //   modalview.display,
  //   modalview.modal,
  //   0,
  //   445
  // );

  // console.log('eventX', e.clientX);
  // console.log(_vector.x * _widthHalf + _widthHalf);
  // console.log('eventY', e.clientY);
  // console.log(-_vector.y * _heightHalf + _heightHalf);
  // console.log(_canvasContainer.clientWidth)
  // console.log('_offsetY', _offsetY)
  // console.log('_offsetX', _offsetX)
  /**
   *  else if (
      _vector.x * _widthHalf + _widthHalf > 0 &&
      _vector.x * _widthHalf + _widthHalf < 445
    ) {
      console.log('true')
      __setModalProperties(Modal_View.Right.display, Modal_View.Right.modal, 0, 445);
      setMouseX(_vector.x * _widthHalf + _widthHalf + _offsetX);
    }
   */
// console.log('iinerwidth', window.innerWidth);
// console.log('offsset', _canvasContainer.offsetLeft)
/**
 * eventX 875
ViewerScene.js:363 322.01376532940196
ViewerScene.js:364 eventY 713
ViewerScene.js:365 713.1040882359935
 
// console.log('computers');
}
*/
